import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.6",
      d: "M7.5 17.5v-6.167c0-.466 0-.7.091-.878a.83.83 0 0 1 .364-.364C8.134 10 8.367 10 8.834 10h2.333c.467 0 .7 0 .878.09.157.08.285.208.364.365.091.178.091.412.091.878V17.5m4.167-8.75v6.083c0 .934 0 1.4-.182 1.757-.16.314-.414.569-.728.728-.357.182-.823.182-1.757.182H6c-.933 0-1.4 0-1.756-.182a1.67 1.67 0 0 1-.729-.728c-.181-.357-.181-.823-.181-1.757V6.667l5.066-3.8c.574-.43.861-.646 1.176-.729.278-.073.57-.073.849 0M1.667 7.917 9.2 2.267c.287-.216.43-.323.588-.365a.83.83 0 0 1 .425 0c.157.042.3.15.587.365m2.534 1.9L15 5.833 18.334 2.5"
    }, null, -1)
  ])))
}
export default { render: render }